module.exports = __webpack_public_path__ + "i18n/tr.58536534eaf565370721fa2c22dc7d5a.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/tr.json
// module id = 1314
// module chunks = 59